import React from 'react';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';

const DurationTypeFormGroup = ({ value, onChange, intl, disabled }) => {
  const handleChange = e => onChange(parseInt(e.target.value));

  return (
    <div className="form-group">
      <FormGroupPart inputCols="col-sm-10">
        <label className="radio-inline">
          <input
            name="durationType"
            onChange={handleChange}
            disabled={disabled}
            value="0"
            checked={value === 0}
            type="radio"
          />
          {intl.formatMessage(messages.DurationInHours)}
        </label>
        <label className="radio-inline">
          <input
            name="durationType"
            onChange={handleChange}
            disabled={disabled}
            value="1"
            checked={value === 1}
            type="radio"
          />
          {intl.formatMessage(messages.DurationInDays)}
        </label>
        <label className="radio-inline">
          <input
            name="durationType"
            onChange={handleChange}
            disabled={disabled}
            value="2"
            checked={value === 2}
            type="radio"
          />
          {intl.formatMessage(messages.HalfDay)}
        </label>
      </FormGroupPart>
    </div>
  );
};

DurationTypeFormGroup.propTypes = {
  value: PropTypes.oneOf([0, 1, 2]),
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
};
DurationTypeFormGroup.defaultProps = {
  value: 0,
  disabled: false,
};
export default DurationTypeFormGroup;
